export default __webpack_public_path__ + "static/media/Snd_V_Starts.aef05b9a.mp3";